// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceLightningBoltSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.005 2.765C9.13 2.312 9.52 2 9.965 2h6.653c.72 0 1.204.787.915 1.49l-2.429 5.905H17c.811 0 1.284.974.815 1.678l-6.973 10.476c-.582.874-1.876.388-1.813-.681l.348-5.926H7c-.666 0-1.146-.68-.96-1.361z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceLightningBoltSolid;
